import script from "./shangcaixq1.vue?vue&type=script&setup=true&lang=js"
export * from "./shangcaixq1.vue?vue&type=script&setup=true&lang=js"

import "./shangcaixq1.vue?vue&type=style&index=0&id=39462e0e&lang=less&scoped=true"
script.__scopeId = "data-v-39462e0e"

export default script